var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 1.3335H3.9987V2.66683H1.33203V4.00016H3.9987V5.3335H5.33203V1.3335Z",
    fill: "#2D67D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 2.66683H14.6654V4.00016H6.66536V2.66683Z",
    fill: "#2D67D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 7.3335H9.33203V6.00016H10.6654V10.0002H9.33203V8.66683H1.33203V7.3335Z",
    fill: "#2D67D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 12.0002H14.6654V13.3335H5.9987V12.0002Z",
    fill: "#2D67D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 12.0002H1.33203V13.3335H3.33203V14.6668H4.66536V10.6668H3.33203V12.0002Z",
    fill: "#2D67D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 7.3335H11.9987V8.66683H14.6654V7.3335Z",
    fill: "#2D67D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8a11d1085430797477e04df9ba754763.svg";
export { ForwardRef as ReactComponent };